export default "__VITE_ASSET__DBc1kSoV__"